import { Schema, ValidationError } from 'yup';

export type ValidationErrors = Map<string, string>;

const validateSchema = (data: any, schema: Schema): ValidationErrors => {
    try {
        schema.validateSync(data, { abortEarly: false });
        return new Map();
    } catch (err) {
        const errorMap: Map<string, string> = new Map();
        const validationError = err as ValidationError;
        for (const error of validationError.inner) {
            const path = error.path || '';
            errorMap.set(path, error.message);
        }
        return errorMap;
    }
};

export { validateSchema };
